import { api } from './client';

export interface CrashEntry {
  ts: string;
  restart_count: number;
}

export interface CrashSummaryItem {
  game_id: string;
  count_24h: number;
}

export const fetchCrashSummary = (): Promise<{ summary: CrashSummaryItem[] }> =>
  api.get<{ summary: CrashSummaryItem[] }>('/games/crash-summary').then((r) => r.data);

export const fetchGameCrashes = (id: string, limit = 50): Promise<{ crashes: CrashEntry[] }> =>
  api.get<{ crashes: CrashEntry[] }>(`/games/${id}/crashes`, { params: { limit } }).then((r) => r.data);
